import border from '../../border';

const light = (params) => border.hover.light(params);

export default light;
